/**
 *
 * SuggestionBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import SuggestionsIcon from '../../../../assets/v2/SuggestionsIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.yellowDark};
    background: ${COLORS.yellowLight};
    border-color: ${COLORS.yellow};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.yellow};
    }
  }
`;

function SuggestionBadge(props) {
  return (
    <StyledBadge
      icon={<SuggestionsIcon />}
      size="iconLarge"
      variant="outlined"
      {...props}
    />
  );
}

export default memo(SuggestionBadge);
